import { render, staticRenderFns } from "./shiti-compose.vue?vue&type=template&id=52c7b3b2&scoped=true&"
import script from "./shiti-compose.vue?vue&type=script&lang=ts&"
export * from "./shiti-compose.vue?vue&type=script&lang=ts&"
import style0 from "./shiti-compose.vue?vue&type=style&index=0&id=52c7b3b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7b3b2",
  null
  
)

export default component.exports